import React from 'react';
import { useTranslations } from 'next-intl';
import PropTypes from 'prop-types';
import Headline from '../../../../atoms/headline/headline';
import Image from '../../../../atoms/image/image';
import MixedCopy from '../../../../molecules/mixed-copy/mixedCopy';
import Link from '../../../../atoms/link/link';
import StyledTeaser from './teaser.style';
import FilterTag from '../../../../atoms/filter-tag/filterTag';

const Teaser = ({
  headline,
  description,
  bookable = false,
  image,
  uri,
  startTime,
  duration,
  openForAll = false,
  pageTags
}) => {
  const t = useTranslations();
  const startDate = new Date(startTime);

  const endDate = new Date(startDate.getTime() + duration * 60000);

  return (
    <StyledTeaser>
      <div className="teaser__meta">
        {!openForAll && bookable && (
          <FilterTag className="teaser__tag--bookable" inverted>
            {t('calendar.seatsLeftShort')}
          </FilterTag>
        )}
        {openForAll && (
          <FilterTag className="teaser__tag--open" border>
            Open For All
          </FilterTag>
        )}
        {!openForAll && !bookable && (
          <FilterTag className="teaser__tag--fully-booked" inverted>
            {t('calendar.soldOut')}
          </FilterTag>
        )}
        {startTime && duration && (
          <time className="teaser__time">
            {startDate.toLocaleTimeString('de', {
              timeStyle: 'short'
            })}
            –
            {endDate.toLocaleTimeString('de', {
              timeStyle: 'short'
            })}
          </time>
        )}
      </div>
      {image?.src && <Image className="teaser__image" {...image} />}
      <div className="teaser__text">
        {pageTags.length > 0 && (
          <div className="teaser__page-tags">
            {pageTags.map(item => (
              <FilterTag key={item.id} border>
                {item.title}
              </FilterTag>
            ))}
          </div>
        )}
        <Headline tag="h3" teaser>
          {headline}
        </Headline>
        <div className="teaser__copy">
          <MixedCopy fullWidth html={description} />
        </div>
      </div>
      {uri && (
        <div className="teaser__book-btn">
          <div className="teaser__book-btn-container">
            <Link href={`${uri}`} title="Mehr details" className="teaser__button">
              {t('more')}
            </Link>
          </div>
        </div>
      )}
    </StyledTeaser>
  );
};

Teaser.propTypes = {
  headline: PropTypes.string.isRequired,
  description: PropTypes.string,
  startTime: PropTypes.string,
  duration: PropTypes.number,
  bookable: PropTypes.bool,
  openForAll: PropTypes.bool,
  image: PropTypes.shape(),
  uri: PropTypes.string,
  pageTags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string
    })
  )
};

export default Teaser;
